import React, { useState } from "react";
import WithdrawalRequestsModal from "./withdrawal-requests-modal";

const MyWithdrawalRequestsButton = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <div className="d-flex align-items-center justify-content-center m-2">
        <div
          style={{
            color: "white",
            background: "transparent",
            cursor: "pointer",
            border: "none",
            fontSize: 18,
            fontStyle: "italic",
            textDecoration: "underline",
          }}
          onClick={() => setShowModal(true)}
        >
          Withdrawal History
        </div>
      </div>
      <WithdrawalRequestsModal show={showModal} onHide={() => setShowModal(false)} />
    </div>
  );
};

export default MyWithdrawalRequestsButton; 